import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AppProperties extends BaseComponent {
	
	static get properties() {
		return {
			local: {type: Boolean},
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var propertiesGrid = this;
		setTimeout(function(){
			propertiesGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var propertiesGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}				
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'code',
					header: 'Key',					
					width: '9em'
				},
				{						
					path: 'description',
					header: 'Value',						
					'flex-grow': '1'						
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		propertiesGrid.append(flexLayout);
		
		var actionRefresh = function() {
			var loadMask = grid.showLoading();			
			if (propertiesGrid.local) {
				Service.getNodeService().getProperties(propertiesGrid.nodeId).then(function(data){
					loadMask.remove();
					var normalized = [];
					data.forEach(function(prop){
						normalized.push({
							code: prop.key,
							description: prop.value
						});
					});
					grid.activeItem = null;
					grid.items = normalized;
				});
			} else {			
				Service.getApplicationService().getAppProperties().then(function(data){
					loadMask.remove();
					grid.activeItem = null;
					grid.items = data;				
				});
			}
		};
		actionRefresh();
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Property',
				icon: 'lumo:eye',
				width: 600,
				height: 250,
				listeners: {
					ready: function() {
						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',														
											label: 'Key',
											name: 'code',
											'item-value-path': 'code',
											'item-label-path': 'description',				
											postinit: function(combo) {
												Service.getApplicationService().getAvailableAppPropertiesKey().then(function(data){
													combo.items = data;													
												});
											},
											placeHolder: 'Select'						
										},
										{
											tag: 'vaadin-text-field',
											label: 'Value',
											name: 'description',
											maxlength: 255,
											required: true
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {

															formPanel.submitForm({
																actualCall: function(data) {
																	if (propertiesGrid.local) {
																		var propView = {
																			key: data.code,
																			value: data.description
																		};																		
																		return Service.getNodeService().saveProperty(propertiesGrid.nodeId, propView);
																	} else {																	
																		return Service.getApplicationService().saveAppProperties(data);
																	}
																},
																success: function(data, responseData) {
																	actionRefresh();
																	addEditWin.close();
																	window.DL.MessageUtil.showToast('Success', 'Saved: ' + data.description, {
																		theme: 'success'
																	});	
																}
															});																

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);			

						if (record) {
							//load form
							formPanel.load(record);
						}
						
					}
				}
			});
			
			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete: ' + record.description + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Property...');
							
							var success = function() {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed: ' + record.description, {									
									theme: 'success'
								});
								actionRefresh();
							};
							
							if (propertiesGrid.local) {
								Service.getNodeService().deleteProperty(propertiesGrid.nodeId, record.code).then(function(){
									success();
								});
							} else {
								Service.getApplicationService().deleteAppProperties(record.code).then(function(){
									success();
								});		
							}
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
	}	
	
};
customElements.define('dl-properties', AppProperties);